import { useTranslation } from "react-i18next";

import { Text } from "chameleon/lib/components";

import { FormTitle } from "checkout-experience/components/forms/form-title";
import { useChexContext } from "checkout-experience/providers/chex-context-wrapper";

const ShippingAddress = () => {
  const { t } = useTranslation(["combined"]);
  const { checkoutSession } = useChexContext();
  const { shippingAddress } = checkoutSession ?? {};

  const {
    recipientName,
    line1,
    line2,
    locality,
    administrativeArea,
    postalCode,
    regionCode,
  } = shippingAddress || {};

  // TODO: regionCode should be matched up to complete country... add address formatting by country
  return (
    <>
      <span id="shippingAddressSectionHeaderId" hidden>
        {t("shippingAddress")}
      </span>
      <FormTitle title={t("shippingAddress")} />
      <div>
        <Text styleVariant="body">{recipientName || ""}</Text>
        <Text styleVariant="body">{line1 || t("error.no-address-listed")}</Text>
        <Text styleVariant="body">{line2 || ""}</Text>
        <Text styleVariant="body">
          {locality || ""}, {administrativeArea || ""}&nbsp;
          {postalCode || ""}
        </Text>
        <Text styleVariant="body">{regionCode || ""}</Text>
      </div>
    </>
  );
};

export default ShippingAddress;
